"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx3 = _interopRequireDefault(require("clsx"));

var _reactPerfectScrollbar = _interopRequireDefault(require("react-perfect-scrollbar"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _Placeholder = require("./Placeholder");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var styles = {
  wrapper: {
    position: 'relative',
    overflow: 'hidden'
  },
  container: {
    display: 'inline-flex',
    flex: '1 1 auto'
  },
  middle: {
    marginLeft: -10
  }
};

var renderPlaceholders = function renderPlaceholders(props) {
  var classes = props.classes,
      quantity = props.difference,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      childrenWithProps = props.childrenWithProps;

  if (quantity) {
    var placeholders = [];
    var index = 0;

    while (index < quantity) {
      switch (variant) {
        case 'small':
          placeholders.push( /*#__PURE__*/_react["default"].createElement(_Placeholder.PlaceholderSmall, {
            key: index,
            first: index === 0,
            quantity: childrenWithProps.length
          }));
          break;

        case 'simple':
          placeholders.push( /*#__PURE__*/_react["default"].createElement(_Placeholder.PlaceholderSimple, {
            key: index,
            first: index === 0,
            quantity: childrenWithProps.length
          }));
          break;

        default:
          placeholders.push( /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
            key: index,
            className: classes.middle
          }, /*#__PURE__*/_react["default"].createElement(_Placeholder.Placeholder, null)));
          break;
      }

      index++;
    }

    return placeholders;
  }
};

var Timeline = /*#__PURE__*/function (_Component) {
  _inherits(Timeline, _Component);

  var _super = _createSuper(Timeline);

  function Timeline() {
    _classCallCheck(this, Timeline);

    return _super.apply(this, arguments);
  }

  _createClass(Timeline, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollbar = this.scrollbar;
      scrollbar.scrollLeft = scrollbar.offsetWidth;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          _this$props$variant = _this$props.variant,
          variant = _this$props$variant === void 0 ? 'default' : _this$props$variant,
          _this$props$height = _this$props.height,
          height = _this$props$height === void 0 ? variant === 'small' ? 95 : variant === 'simple' ? 135 : 265 : _this$props$height,
          _this$props$minEvents = _this$props.minEvents,
          minEvents = _this$props$minEvents === void 0 ? 0 : _this$props$minEvents,
          _this$props$maxEvents = _this$props.maxEvents,
          maxEvents = _this$props$maxEvents === void 0 ? 0 : _this$props$maxEvents,
          placeholder = _this$props.placeholder,
          PerfectScrollbarProps = _this$props.PerfectScrollbarProps;
      var difference = children ? minEvents - children.length : minEvents;
      var childrenWithProps = children ? _react.Children.map(children, function (child, index) {
        return /*#__PURE__*/(0, _react.cloneElement)(child, {
          variant: variant,
          placeholder: placeholder,
          first: index === 0
        });
      }) : [];
      var placeholders = renderPlaceholders({
        classes: classes,
        difference: difference,
        variant: variant,
        childrenWithProps: childrenWithProps
      });
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        className: classes.wrapper,
        style: {
          height: height
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactPerfectScrollbar["default"], _extends({
        containerRef: function containerRef(element) {
          return _this.scrollbar = element;
        }
      }, PerfectScrollbarProps), /*#__PURE__*/_react["default"].createElement(_CssBaseline["default"], null), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        className: classes.container
      }, maxEvents ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, childrenWithProps.map(function (child, index) {
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: index
        }, index < maxEvents && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          className: (0, _clsx3["default"])(_defineProperty({}, classes.middle, variant === 'default' && index > 0 && index < children.length))
        }, child));
      })) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, childrenWithProps.map(function (child, index) {
        return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          key: index,
          className: (0, _clsx3["default"])(_defineProperty({}, classes.middle, variant === 'default' && index > 0 && index < children.length))
        }, child);
      })), minEvents > 0 && difference > 0 && placeholder && placeholders)));
    }
  }]);

  return Timeline;
}(_react.Component);

var _default = (0, _withStyles["default"])(styles)(Timeline);

exports["default"] = _default;